// extracted by mini-css-extract-plugin
export default {"container":"AccessDenied_container__2QlY4","absolute":"AccessDenied_absolute__aWttS","title":"AccessDenied_title__rLYGs","icon":"AccessDenied_icon__g3ijC"};